class AnnouncementTimer extends HTMLElement {
  /**
   * ## Constructor
   * Init vars with DOM elements
   */
  constructor() {
    super();
    this.container = this.querySelector(".announcement-timer");
    this.timerContent = this.querySelector("#timer-content");
  }

  /**
   * ## Connected Callback Hook
   * - Method called when the element is attached to the DOM
   * - Starts the timer countdown if enabled
   */
  connectedCallback() {
    // Get dataset elements
    const { enableTimer, date } = this.container.dataset;

    // Init if is it enable
    if (enableTimer === "true") {
      // Parse ending date from data attr or build default ending date
      const endingDate = date ? new Date(date) : this.buildEndingDate();
      this.initTimer(endingDate);
    }
  }

  /**
   * ## Disconnected Callback Hook
   * - Method called when the element is detached from the DOM
   * - Clears the interval to stop the timer.
   */
  disconnectedCallback() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  /**
   * ## Initialize timer
   * @param {Date} endingDate  The date and time when the timer should end.
   */
  initTimer(endingDate) {
    this.countdownInterval = setInterval(() => {
      // Get current date
      const currentDate = new Date().getTime();

      // Calculate time remaining
      const timeRemaining = endingDate.getTime() - currentDate;

      if (timeRemaining <= 0) {
        // The timer has reached or passed the ending date
        clearInterval(this.countdownInterval);
        this.timerContent.innerHTML = "0d 0h 0m 0s";
      } else {
        // Update the timer display with remaining time
        this.updateTimeDisplay(timeRemaining);
      }
    }, 1000);
  }

  /**
   * ## Updates the timer with the remaining time
   * @param {number} timeRemaining - The time remaining in milliseconds
   */
  updateTimeDisplay(timeRemaining) {
    // Calculate days, hours, minutes and seconds from the time remaining
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Update the timer content with the calculated values
    this.timerContent.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  /**
   * ## Builds a default ending date for the timer (ends of current day)
   * @returns { Date } - The default ending date
   */
  buildEndingDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();

    // Set the ending time to 23:59 (end of current day)
    return new Date(year, month, day, 23, 59);
  }
}
customElements.define("announcement-timer", AnnouncementTimer);
